import axios from 'axios';
import {showSuccess, showError} from './notyf';

import { ModAlert } from '../custom-libs/modAlert/modAlert.js';
import '../custom-libs/modAlert/modAlert.css';

class Cart {
    static BASE_URL = '/cart/update';
    static basketClickListener = null; // Ссылка на текущий обработчик событий

    // Общий метод для отправки POST-запросов
    static  sendPostRequest(action, data) {
        return axios.post(`${Cart.BASE_URL}`, {
            action: action,
            ...data // Распаковываем объект data в запрос
        })
            .then(response => {
                console.log(`${action} action response:`, response.data);
                // Проверяем статус ответа
                if (response.data.status === 'success') {
                    // Выводим успешное сообщение
                    // showSuccess(response.data.message);
                } else {
                    // Выводим сообщение об ошибке
                    showError(response.data.message);
                }
                Cart.updateRightCart(response.data);
                //Сообщить что корзина обновлена
                if (action !== 'get') {
                    Cart.sendCartUpdated(response.data);
                }
                if (window.location.pathname === '/confirm'){
                    Cart.updateBalls(response.data)
                    Cart.updateConfirmed(response.data);
                }

                return response.data;
            })
            .catch(error => {
                console.error(`Error during ${action} action:`, error);
                throw error;
            });
    }

    // Метод для обновления корзины
    static updateRightCart(data) {
        // Получаем контейнер для карточек товаров в корзине
        const basketCardsContainer = document.querySelector('.basket__cards');

        // Удалить старый обработчик событий, если он существует
        if (Cart.basketClickListener) {
            basketCardsContainer.removeEventListener('click', Cart.basketClickListener);
        }
        let cart_count = data['cart_item']['cart']['quantity'];
        let header_basket = document.querySelector('.header__basket');
        header_basket.querySelector('.count_cart').textContent = cart_count;

        // Очистить существующие карточки товаров
        basketCardsContainer.innerHTML = '';

        // Получаем массив товаров из данных
        const items = data.cart_item.cart.items;
        if (items) {
            // Создаем HTML для каждой карточки товара и вставляем в контейнер
            items.forEach(item => {
                const basketCard = document.createElement('div');
                basketCard.classList.add('basket__card');

                basketCard.innerHTML = `
    <img src="${item.image ? '/images/products/' + item.image : '/img/no-found-n.png'}" alt="product">
    <div class="basket__info">
        <a href="${item.href}">${item.name}</a>
        <div class="basket__flex">
            <span>${Math.round(item.price/item.quantity)} р</span>
            <div class="basket__counter">
                <button class="button__decrement" data-product_id="${item.id}">-</button>
                <span>${item.quantity}</span>
                <button class="button__increment" data-product_id="${item.id}">+</button>
            </div>
        </div>
        <p>В корзине ${item.quantity} товар(ов) на сумму ${item.price}р</p>
    </div>
`;

                basketCardsContainer.appendChild(basketCard);
            });
        }

        // Создать новый обработчик событий
        Cart.basketClickListener = function(event) {
            const target = event.target;
            const counter = target.closest('.basket__counter');
            if (!counter) return; // Если нет ближайшего .basket__counter, выходим

            const quantitySpan = counter.querySelector('span');
            const quantity = parseInt(quantitySpan.textContent, 10);

            // Получаем product_id из атрибута data-product_id
            const productId = target.dataset.product_id;

            if (target.classList.contains('button__increment')) {
                let ch_quantity = quantity + 1;
                cart.setItemQuantity(productId, ch_quantity);
                console.log('Incremented product:', productId, 'New quantity:', ch_quantity);
            } else if (target.classList.contains('button__decrement') && quantity > 1) {
                let ch_quantity = quantity - 1;
                cart.setItemQuantity(productId, ch_quantity);
                console.log('Decremented product:', productId, 'New quantity:', ch_quantity);
            } else if (target.classList.contains('button__decrement') && quantity === 1) {
                cart.removeItem(productId);
                console.log('removeItem:', productId, 'New quantity:', 0);
            }
        };

        // Добавить новый обработчик событий
        basketCardsContainer.addEventListener('click', Cart.basketClickListener);
    }

    static updateBalls(data) {
        const ballsInput   = document.querySelector('#ballsInput');
        if (!ballsInput){return;}

        const availableForUse = data.cart_item?.cart?.balls?.available_for_use;
        if (availableForUse >= 0){
            ballsInput.value = availableForUse
        }
    }
    static updateConfirmed(data) {
        const btn   = document.querySelector('#confirm-order');
        const hint  = document.querySelector('#confirm-hint');
        const minEl = document.querySelector('#min-sum');
        const progressBtn = document.querySelector('#progress-btn');

        if (!btn || !hint || !progressBtn) return;

        const show      = data.cart_item?.cart?.buttonConfirmStatus;
        const minSum    = data.cart_item?.cart?.minSummOrder ?? 0;
        const current = data.cart_item?.cart?.totalAmount ?? 0; // ваша текущая сумма
        const remain  = Math.round(Math.max(0, minSum - current));
        // кнопка
        btn.classList.toggle('d-none', !show);

        // подсказка
        hint.classList.toggle('d-none', show);
        minEl.textContent = minSum;

        const keyMinSumAlert = 'minSumAlertShown';
        /* 3. показываем уведомление, если кнопки нет */
        if (!show && !sessionStorage.getItem(keyMinSumAlert)) {
            ModAlert.addAlert({
                type: 'warning',
                text: '<p>До возможности купить наши товары с бесплатной доставкой осталось совсем чуть-чуть!</p>' +
                    '<p>Минимальная сумма заказа в нашем магазине от ' + minSum + ' рублей.</p>' +
                    '<p>Посмотрите наши акционные предложения–наверняка там найдётся что-то нужное. Помните, котик или собака сами себя не накормят, запас никогда не помешает!</p>' +
                    '<p>Заказы на сумму до ' + minSum + ' рублей с бесплатной доставкой можно оформить в нашем магазине на <a href="https://market.yandex.ru/business--simbio-shop/923914 " target="_blank">Яндекс-Маркете</a></p>',
                timeout: 10000,
            });
            sessionStorage.setItem(keyMinSumAlert, '1');
        }

        const percent = Math.min(100, (current / minSum) * 100);
        progressBtn.style.setProperty('--progress', percent + '%');

        // когда достигли 100 % – меняем фон всей кнопки
        progressBtn.classList.toggle('bg-success', percent >= 100);
        progressBtn.classList.toggle('bg-secondary', percent < 100);
        document.getElementById('remain').textContent = remain.toLocaleString('ru-RU');

    }

    // Метод для добавления товара в корзину
    addItem(productId, quantity = 1) {
        return Cart.sendPostRequest('add', { productId: productId, quantity: quantity });
    }
    getItems() {
        return Cart.sendPostRequest('get');
    }


    // Метод для удаления товара из корзины
    removeItem(productId) {
        return Cart.sendPostRequest('remove', {productId: productId});
    }

    // Метод для установки определенного количества товара
    setItemQuantity(productId, quantity) {
        return Cart.sendPostRequest('set', { productId: productId, quantity: quantity });
    }

    // Метод для удаления определенного количества товара
    deleteItemQuantity(productId, quantity) {
        return Cart.sendPostRequest('delete', { productId: productId, quantity: quantity });
    }

    // Метод для получения общей стоимости корзины
    getTotal() {
        return axios.get(`${Cart.BASE_URL}/total`)
            .then(response => {
                console.log('Total price:', response.data.totalPrice);
                return response.data.totalPrice;
            })
            .catch(error => {
                console.error('Error getting total price:', error);
                throw error;
            });
    }

    static sendCartUpdated(data) {

        // Создаем и отправляем кастомное событие cartUpdated
        const event = new CustomEvent('cartUpdated', {
            detail: data
        });

        document.dispatchEvent(event);
    }

    setPriceShipping(methodId, price) {
        return Cart.sendPostRequest('setPriceShipping',
            {
                methodId: methodId,
                price: price
            });
    }
    setShippingAddress(addressData) {
        // Проверяем, является ли addressData объектом (не массивом и не null)
        if (!addressData || typeof addressData !== 'object' || Array.isArray(addressData)) {
            alert('Требуется объект с данными адреса');
        }

        return Cart.sendPostRequest('setShippingAddress', {
            city: addressData.city || '',
            street: addressData.street || '',
            house: addressData.house || '',
            apartment: addressData.apartment || ''
        });
    }
    setPaymentMethod(methodId) {
        return Cart.sendPostRequest('setPaymentMethod', {methodId: methodId});
    }
    setGift(type, productId) {
        return Cart.sendPostRequest('setGift', {type: type, productId: productId});
    }
    setCoupon(couponCode) {
        return Cart.sendPostRequest('setCoupon', {'coupon': couponCode});
    }
    delCoupon() {
        return Cart.sendPostRequest('delCoupon');
    }

    setBalls(balls) {
        return Cart.sendPostRequest('setBalls', {'balls': balls});
    }
    delBalls() {
        return Cart.sendPostRequest('delBalls');
    }



}

const counter = document.querySelector('.modal-basket__counter span');
const buttonsCounter = document.querySelectorAll('.modal-basket__counter button');
let count = parseInt(counter.textContent);
let productId = counter.dataset.product_id;
buttonsCounter[1].addEventListener('click', () => {
    cart.setItemQuantity(productId, ++count);
});
buttonsCounter[0].addEventListener('click', () => {
    if (count >= 0) {
        cart.setItemQuantity(productId, --count);
    }
});

// Проверка на дублирование
if (window.__cart_initialized) {
    // Уже есть глобальный экземпляр, используем его
    var cart = window.cart;
} else {
    // Первичная инициализация
    window.__cart_initialized = true;
    var cart = new Cart();
    window.cart = cart; // Для доступа из глобального скрипта (Twig)
}
cart.getItems();
export default cart;
document.querySelectorAll('.add-to-cart').forEach(button => {
    button.addEventListener('click', (event) => {
        const target = event.target;
        const productId = target.dataset.product_id;
        const quantityElement = target.closest('.cart__basket').querySelector('.quantity');
        const quantity = parseInt(quantityElement.textContent, 10);

        // Добавляем товар в корзину
        cart.addItem(productId, quantity).then(data => {
            console.log('Add Item Response:', data);
            showSuccess('Товар добавлен в корзину!');
        }).catch(error => {
            console.error('Error adding item to cart:', error);
            showError('Ошибка при добавлении товара в корзину.');
        });
    });
});

// Добавляем обработчик события на кнопку с классом cart__add-button
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cart__add-button').forEach(button => {
        button.addEventListener('click', (event) => {
            // Получаем значение data-product_id текущей кнопки
            const productId = button.getAttribute('data-product_id');

            // Находим элемент с классом add-to-cart и тем же data-product_id
            const addToCartElement = document.querySelector(`.add-to-cart[data-product_id="${productId}"]`);

            // Если такой элемент найден, имитируем клик по нему
            if (addToCartElement) {
                addToCartElement.click();
            } else {
                console.log(`Элемент с data-product_id="${productId}" не найден`);
            }
        });
    });
});


const buttonCard = document.querySelectorAll('.card-product__basket');
const modalBasketAdd = document.querySelector('.modal-basket');
const buttonClose = document.querySelector('.modal-basket__close');
buttonCard.forEach(button => {
    button.addEventListener('click', () => {
        const productId = button.dataset.product_id;
        cart.addItem(productId, 1).then(data => {
            let product_image = modalBasketAdd.querySelector('.product-image img');
            let product_name = modalBasketAdd.querySelector('a.product-name');
            let product_price_one = modalBasketAdd.querySelector('span.product-price');
            let product_desc = modalBasketAdd.querySelector('p.desc-cart-item');

            let item_active = data['cart_item']['item_active']
            let quantity = item_active['quantity'];
            let price = item_active['price'];
            product_image.src = '/images/products/' + item_active['image'];
            product_name.textContent = item_active['name'];
            product_price_one.textContent = price + ' р';
            product_desc.textContent = generateCartDescription(quantity, price);
            // modalBasketAdd.classList.add('activeModalBasket');

            modalBasketAdd.classList.add('activeModalBasket');
        }).catch(error => {
            console.error('Error adding item to cart:', error);
            showError('Ошибка при добавлении товара в корзину.');
        });

    });
});
const containerAdress = document.querySelector('.placement__inps-bottom');

// Все радио, кроме СДЭК
if (containerAdress) {
    document.querySelectorAll('input[name="cart[shippingMethod]"]:not(#cart_shippingMethod_1)').forEach(radio => {
        radio.addEventListener('click', function () {
            if (!this.checked) return;

            // Разблокируем адрес
            containerAdress.classList.remove('disabled');
            containerAdress.querySelectorAll('input').forEach(input => {
                input.readOnly = false;
            });

            // Сбрасываем цену доставки
            document.getElementById("cart_priceShipping").value = 0;
            cart.setPriceShipping(this.value, 0);

            console.log('Выбран другой способ доставки:', this.value);
        });
    });
}

const radioInput2 = document.getElementById('cart_shippingMethod_2');
if (radioInput2) {
// Обработчик события click для радио-кнопки
    radioInput2.addEventListener('click', function () {
        document.getElementById("cart_priceShipping").value = 0;
        const selectedRadio = document.querySelector('input[name="cart[shippingMethod]"]:checked');
        if (selectedRadio) {
            const value = selectedRadio.value;
            cart.setPriceShipping(value, 0);
        } else {
            console.log('Нет выбранного способа доставки');
        }
    });
}


/**
 * Обработка выбора метода оплаты на странице оформления заказа.
 *
 *
 * Этот скрипт добавляет обработчики событий для радиокнопок и их меток,
 * чтобы выделять активный метод оплаты и получать выбранное значение.
 */

const allButtonGroups = document.querySelectorAll('.placement__pay .placement__buttons-click, .placement__delivery .placement__buttons-click');

allButtonGroups.forEach(buttonGroup => {
    buttonGroup.addEventListener('click', (event) => {
        const label = event.target.closest('.button-radio');
        if (!label) return;

        buttonGroup.closest('.placement__pay, .placement__delivery')
            ?.querySelector('.invalid-feedback')
            ?.classList.remove('d-block');
        // UI: переключение активного состояния
        buttonGroup.querySelectorAll('.button-radio').forEach(el => el.classList.remove('activeButtonPlacement'));
        label.classList.add('activeButtonPlacement');

        // Получаем input
        const input = document.getElementById(label.getAttribute('for'));
        if (!input) return;

        const value = input.value;

        // Определяем тип по родительскому контейнеру
        const isPay = buttonGroup.closest('.placement__pay');
        const isDelivery = buttonGroup.closest('.placement__delivery');

        if (isPay) {
            // Оплата
            cart.setPaymentMethod(value);
        }
        else if (isDelivery) {
            // Доставка: пропускаем СДЭК (id=1)
            if (input.id === 'cart_shippingMethod_1') return;

            document.getElementById("cart_priceShipping").value = 0;
            cart.setPriceShipping(value, 0);
        }
    });
});


function getCorrectWordForm(quantity, forms) {
    const lastDigit = quantity % 10;
    const lastTwoDigits = quantity % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return forms[2]; // "товаров"
    }

    if (lastDigit === 1) {
        return forms[0]; // "товар"
    } else if (lastDigit >= 2 && lastDigit <= 4) {
        return forms[1]; // "товара"
    } else {
        return forms[2]; // "товаров"
    }
}

function generateCartDescription(quantity, price) {
    const wordForms = ['товар', 'товара', 'товаров'];
    const wordForm = getCorrectWordForm(quantity, wordForms);
    // Перемножаем количество и цену и округляем до целого числа
    const totalPrice = Math.round(quantity * price);

    return `В корзине ${quantity} ${wordForm} на сумму ${totalPrice} р`;
}

document.addEventListener('DOMContentLoaded', () => {
    const loginButton = document.getElementById('in-auth');
    loginButton.addEventListener('click', () => {

        const authModal = document.getElementById('authModal')
        const name       = authModal.querySelector('#username').value;
        const pas        = authModal.querySelector('#password').value;
        const csrfToken  = authModal.querySelector('input[name="_csrf_token"]').value;

        axios.post('/ajax-login', {
            _username: name,
            _password: pas,
            _csrf_token: csrfToken
        })
            .then(function (response) {
                if (response.data.success) {
                    window.location.href = '/';
                    alert("Авторизация пройдена");
                } else {
                    alert('Введен не правильный логин или пароль.');
                }
            })
            .catch(function (error) {
                console.log(error);
                alert("Что-то пошло не так. Попробуйте еще раз...");
            });
    });


})

// Получаем элемент
const placementBasketCards = document.querySelector('.placement_basket__cards');

// Проверяем, существует ли элемент
if (placementBasketCards) {
    // Если элемент существует, добавляем обработчик событий на родительский контейнер
    placementBasketCards.addEventListener('click', function(event) {
        let productId = event.target.dataset.id_product;
        let quantity = 0;
        let counter = null;

        // Проверяем, является ли нажатый элемент кнопкой увеличения или уменьшения
        if (event.target.classList.contains('button__increment')) {
            // Получаем текущее значение счетчика
            counter = event.target.previousElementSibling;
            if (counter) {
                quantity = parseInt(counter.textContent, 10);
                // Увеличиваем значение счетчика
                quantity++;
            }
        } else if (event.target.classList.contains('button__decrement')) {
            // Получаем текущее значение счетчика
            counter = event.target.nextElementSibling;
            if (counter) {
                quantity = parseInt(counter.textContent, 10);
                // Уменьшаем значение счетчика, если оно больше 1
                if (quantity > 1) quantity--;
            }
        } else if (event.target.classList.contains('button__remove')) {
            // Обновляем корзину
            let requestUpdateRemoveCart = cart.removeItem(productId);
            requestUpdateRemoveCart.then(response => {
                if (response && response.cart_item) {
                    if (response.cart_item.item_active) {
                        counter.textContent = response.cart_item.item_active.quantity;
                    }
                    if (response.cart_item.cart) {
                        let cartRequest = response.cart_item.cart;
                        // Обновляем корзину при загрузке страницы
                        updateItemsCart();
                        // Обновляем информацию в placement__right
                        UpdateRightConfirmCart(cartRequest)
                    }
                }
            }).catch(error => {
                console.error('Ошибка при обновлении корзины:', error);
            });
        }

        // Проверяем, что counter и productId определены
        if (counter && productId) {
            let requestUpdateCart = cart.setItemQuantity(productId, quantity);
            requestUpdateCart.then(response => {
                if (response && response.cart_item) {
                    if (response.cart_item.item_active) {
                        counter.textContent = response.cart_item.item_active.quantity;
                    }
                    if (response.cart_item.cart) {
                        let cartRequest = response.cart_item.cart;
                        // Обновляем корзину при загрузке страницы
                        updateItemsCart();
                        // Обновляем информацию в placement__right
                        UpdateRightConfirmCart(cartRequest)
                    }
                }
            }).catch(error => {
                console.error('Ошибка при обновлении корзины:', error);
            });
        }
    });

    placementBasketCards.addEventListener('click', function(event) {
        // Проверяем, что клик был на кнопке с классом .setgift или .setsale
        if (event.target.classList.contains('setgift') || event.target.classList.contains('setsale')) {
            const button = event.target;
            const productId = button.getAttribute('data-id_product');

            if (button.classList.contains('setgift')) {
                // Если нажата кнопка с классом setgift
                cart.setGift('gift', productId);
            } else if (button.classList.contains('setsale')) {
                // Если нажата кнопка с классом setsale
                cart.setGift('sale', productId);
            }

            // Обновляем корзину
            updateItemsCart();
        }
    });
}

// Добавляем обработчик событий для всех кнопок с классами getgift и getsale
function updateItemsCart() {
    // URL для AJAX-запроса
    const url = '/confirm/cart-items';

    // Используем Axios для получения содержимого корзины
    axios.get(url)
        .then(response => {
            // Вставляем полученный HTML в блок корзины
            placementBasketCards.innerHTML = response.data;
        })
        .catch(error => {
            // Обрабатываем ошибки
            console.error('There has been a problem with your Axios request:', error);
            placementBasketCards.innerHTML = 'Failed to load cart items.';
        });
}

function UpdateRightConfirmCart(cartRequest) {
    const placementRight = document.querySelector('.placement__right');
    if (placementRight) {
        // Обновляем информацию о товарах в корзине
        const placementBasket = placementRight.querySelector('.placement__basket');
        if (placementBasket) {

            // Обновляем количество товаров


            const productsCount = placementBasket.querySelector('.placement__product span');
            if (productsCount) {
                productsCount.textContent = `Товары (${cartRequest.quantity})`;
            }

            // Обновляем общую стоимость товаров
            const productsPrice = placementBasket.querySelector('.placement__product p');
            if (productsPrice) {
                productsPrice.textContent = `${cartRequest.price_products} р`;
            }

            // Обновляем информацию о скидке
            const shipping = placementBasket.querySelector('.placement__shipping p');
            if (shipping) {
                shipping.textContent = `${cartRequest.price_shipping} р`;
            }

            // Обновляем информацию о скидке
            const discount = placementBasket.querySelector('.placement__discoint p');
            if (discount) {
                discount.textContent = `— ${cartRequest.discount} р`;
            }

            // Обновляем общую стоимость к оплате
            const totalPrice = placementBasket.querySelector('.placement__total p');
            if (totalPrice) {
                totalPrice.textContent = `${cartRequest.total_price} р`;
            }
        }
    }
}

const couponForm = document.getElementById('couponForm');

if (couponForm) {
    // Добавляем обработчик события submit для формы
    couponForm.addEventListener('submit', function (event) {
        // Отменяем стандартное действие формы (перезагрузку страницы)
        event.preventDefault();

        const couponInput = document.getElementById('couponInput');
        const couponButton = couponForm.querySelector('button[type="submit"]');
        const couponCode = couponInput.value.trim();

        // Функция для обновления интерфейса
        function updateCouponInterface(response) {
            let cartRequest = response.cart_item.cart
            let newCouponCode = cartRequest.coupon_code;

            // Обновляем поле ввода
            couponInput.value = newCouponCode || '';

            // Обновляем кнопку в зависимости от значения couponCode
            if (newCouponCode) {
                // Если couponCode не пустой, устанавливаем текст "Отменить купон" и класс del-coupon
                couponButton.textContent = 'Отменить купон';
                couponButton.classList.remove('set-coupon');
                couponButton.classList.add('del-coupon');
            } else {
                // Если couponCode пустой, устанавливаем текст "Применить купон" и класс set-coupon
                couponButton.textContent = 'Применить купон';
                couponButton.classList.remove('del-coupon');
                couponButton.classList.add('set-coupon');
            }
            updateItemsCart()
            UpdateRightConfirmCart(cartRequest)
        }

        // Проверяем класс кнопки
        if (couponButton.classList.contains('set-coupon')) {
            // Если кнопка имеет класс set-coupon, применяем купон
            if (couponCode) {
                // Вызываем функцию cart.setCoupon с кодом купона
                cart.setCoupon(couponCode)
                    .then(response => {
                        updateCouponInterface(response);
                    })
                    .catch(error => {
                        console.error('Error setting coupon:', error);
                        alert('Не удалось применить купон. Пожалуйста, попробуйте снова.');
                    });
            } else {
                alert('Пожалуйста, введите код купона.');
            }
        } else if (couponButton.classList.contains('del-coupon')) {
            // Если кнопка имеет класс del-coupon, отменяем купон
            cart.delCoupon()
                .then(response => {
                    updateCouponInterface(response);
                })
                .catch(error => {
                    console.error('Error deleting coupon:', error);
                    alert('Не удалось удалить купон. Пожалуйста, попробуйте снова.');
                });
        }
    });
}
const ballsForm = document.getElementById('ballsForm');
// Обработка формы баллов
if (ballsForm) {
    ballsForm.addEventListener('submit', function (event) {
        event.preventDefault();

        const ballsInput = document.getElementById('ballsInput');
        const ballsButton = ballsForm.querySelector('button[type="submit"]');
        const ballsValue = ballsInput.value.trim();

        function updateBallsInterface(response) {
            let cartRequest = response.cart_item.cart
            let newBallsValue = cartRequest.balls.used_balls;

            if (newBallsValue) {
                ballsInput.value = newBallsValue || '';
                ballsButton.textContent = 'Сбросить баллы';
                ballsButton.classList.remove('set-balls');
                ballsButton.classList.add('del-balls');
            } else {
                let newBallsValue = response.cart_item.cart.balls.available_for_use;
                ballsInput.value = newBallsValue || '';
                ballsButton.textContent = 'Потратить баллы';
                ballsButton.classList.remove('del-balls');
                ballsButton.classList.add('set-balls');
            }
            updateItemsCart();
            UpdateRightConfirmCart(cartRequest);
        }

        if (ballsButton.classList.contains('set-balls')) {
            if (ballsValue) {
                cart.setBalls(ballsValue)
                    .then(response => {
                        updateBallsInterface(response);
                    })
                    .catch(error => {
                        console.error('Error setting balls:', error);
                        alert('Не удалось применить баллы. Пожалуйста, попробуйте снова.');
                    });
            } else {
                alert('Пожалуйста, введите количество баллов.');
            }
        } else if (ballsButton.classList.contains('del-balls')) {
            cart.delBalls()
                .then(response => {
                    updateBallsInterface(response);
                })
                .catch(error => {
                    console.error('Error deleting balls:', error);
                    alert('Не удалось сбросить баллы. Пожалуйста, попробуйте снова.');
                });
        }
    });
}

const placementCoupon = document.querySelector('.placement__coupon');

if (placementCoupon) {
    function updateCouponBalls() {
        // URL для AJAX-запроса
        const url = '/confirm/cart-coupon';

        // Используем Axios для получения содержимого корзины
        axios.get(url)
            .then(response => {
                // Вставляем полученный HTML в блок корзины
                placementCoupon.innerHTML = response.data;
            })
            .catch(error => {
                // Обрабатываем ошибки
                console.error('There has been a problem with your Axios request:', error);
                placementCoupon.innerHTML = 'Failed to load cart items.';
            });
    }
}